



















import { computed, defineComponent, onBeforeMount, ref, watch } from '@nuxtjs/composition-api';
import useStoresList from '@shared/composables/useStoresList';
import { AustralianState } from '@shared/types/locations';
import { BaseLoader } from '@shared/ui';

import StoresList from '~/components/Stores/StoresList.vue';

const DEFAULT_STATE = AustralianState.ACT;

export default defineComponent({
  name: 'StoresPicker',
  components: { StoresList, BaseLoader },
  props: {
    heading: {
      type: String,
      default: 'AMX Stores',
    },
  },
  setup() {
    const { getStoresByState, states, stores, error } = useStoresList();
    const selectedState = ref<AustralianState>(DEFAULT_STATE);
    const loading = computed(() => !stores.value && !error.value);

    onBeforeMount(() => {
      try {
        const myStore = localStorage.getItem('myStore');
        if (!myStore) return;
        selectedState.value = JSON.parse(myStore).state;
      } catch (err) {
        console.error('Failed to load myStore from localStorage', err);
      }
    });

    watch(
      selectedState,
      (newState) => {
        getStoresByState(newState);
      },
      { immediate: true },
    );

    return {
      states,
      selectedState,
      stores,
      error,
      loading,
    };
  },
});
